import script from "./MenuLateral.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuLateral.vue?vue&type=script&setup=true&lang=js"

import "./MenuLateral.vue?vue&type=style&index=0&id=8657124a&scoped=true&lang=css"

import exportComponent from "/Users/nunosarabando/projects/TravocarStore_2025/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8657124a"]])

export default __exports__